import React from 'react';
// import { Redirect } from "react-router-dom";
import Cookies from 'js-cookie';
// import Highlighter from 'react-highlight-words';
// import { Link } from "react-router-dom";
import {
	Row,
	Col,
	Input,
	Button,
	message,
	Select,
	Spin,
	Form,
} from 'antd';
import {
	SearchOutlined,
	CopyOutlined,
	PrinterOutlined,
} from '@ant-design/icons';

// import axios from 'axios';

import { connect } from 'react-redux';
import {
	initHandler,
	ajaxViewHandler,
	ajaxHandler,
	setConfig,
} from "../../store/actions";

import Config from '../../Config';
import { Helmet } from "react-helmet";

import moment from "moment";

import '../../assets/laporan.css';
import { 
	// RoundedInput, 
	RoundedButton,
	RoundedSelect,
	RoundedDatePicker,
	// ScrollableCol
} from '../../components/RoundedComponents';

const configClass = {
	title: 'LAPORAN TELLER',
	apiUrl: {
		data: 'laporan/api/teller/',
		warna_plat: "master/api/plat",
		jenis_kendaraan: "master/api/jenis/kendaraan/",
		payment: "master/api/payment/?include_deleted=true",
		upt: "pegawai/api/upt/",
		kabupaten: "master/api/kabupaten/",
	},
	pageUrl: {
		cetak: '/laporan/teller'
	},
	breadCrumb: [
		(
			<span>
				<CopyOutlined /> laporan
			</span>
		),
		'teller'
	]

}

const config = new Config();

class LapTeller extends React.Component {
	formRef = React.createRef();

	constructor(props) {
		super(props);
		this.config = new Config();
		this.state = {
			loading: false,
			data: null,
			err: false,

			loadingWarnaPlat: false,
			listWarnaPlat: [],

			loadingJenisKendaraan: false,
			listJenisKendaraan: [],

			loadingPayment: false,
			listPayment: [],

			namauptppd: 'SAMSAT PALANGKARAYA',

			filter: "",

			mulai_dari: "",
			sampai_dengan: "",

			loadingUpt: false,
			listUpt: [],

			loadingKabupaten: null,
			listKabupaten: [],

			loadingPegawai: false,
			listPegawai: [],

			kabupaten_id: "",
			kabId: "",
			pegawai_id: "",

			uptInfo: null, // {id, nama, kabupaten} dari cookie
		}
	}

	UNSAFE_componentWillMount() {
		this.props.initHandler();
	}

	componentDidMount() {
		this.loadMasterList();
		this.readUptCookie();
	}

	readUptCookie() {
		try {
			const rawCookie = Cookies.get(this.config.get_cookie_name() + "_upt");
			if (!rawCookie) return;
			const parsed = JSON.parse(decodeURIComponent(rawCookie));
			if (!parsed.id) return;
			this.setState({
				uptInfo: { id: parsed.id, nama: parsed.nama || '', kabupaten: parsed.kabupaten },
				kabupaten_id: parsed.kabupaten,
			});
			// Set hidden upt field setelah form terpasang
			setTimeout(() => {
				if (this.formRef.current) {
					this.formRef.current.setFieldsValue({ upt: String(parsed.id) });
				}
			}, 100);
		} catch (err) {
			console.warn("Cookie UPT tidak valid:", err);
		}
	}

	handlePrint = () => {
		const printEl = document.querySelector('.lap-teller-print-only');
		if (!printEl) return;
		const parent  = printEl.parentNode;
		const nextSib = printEl.nextSibling;
		printEl.style.display = 'block';
		document.body.appendChild(printEl);
		const siblings = Array.from(document.body.children).filter(el => el !== printEl);
		siblings.forEach(el => { el.style.display = 'none'; });
		window.print();
		siblings.forEach(el => { el.style.display = ''; });
		if (nextSib) parent.insertBefore(printEl, nextSib);
		else parent.appendChild(printEl);
		printEl.style.display = '';
	}

	handleSubmitDetail = (values) => {
		let kabupatenId = null;
		let uptId = null;
		let isCookieValid = false;

		try {
			const rawCookie = Cookies.get(this.config.get_cookie_name() + "_upt");
			if (rawCookie) {
				const decoded = decodeURIComponent(rawCookie);
				const parsed = JSON.parse(decoded);
				kabupatenId = parsed.kabupaten;
				uptId = parsed.id;
				isCookieValid = Boolean(kabupatenId && uptId);
			}
		} catch (err) {
			console.warn("Cookie _upt tidak valid atau tidak ditemukan:", err);
		}

		
		let filter = "";
		// console.log(isCookieValid)
		if (isCookieValid) {
			// console.log(this.state.kabupaten_id)
			filter += (filter == "" ? "?" : "&") + "kabupaten" + "=" + encodeURIComponent(this.state.kabupaten_id);
		}
		for (let key in values) {
			let val = values[key];


			
			// Ambil .value jika object (labelInValue)
			if (val != undefined) {
				if (typeof val == "object" && val != null && "value" in val) {
					val = val.value;
				}

				filter += (filter == "" ? "?" : "&") + key + "=" + encodeURIComponent(val);
			}
		}

		this.setState({ filter });
		this.getData(filter);
	};

	async getData(filter) {
		message.loading({ content: 'Menampilkan laporan...', duration: 0, key: 'toast' });
		this.setState({
			loading: true,
			err: false,
			data: null,
		});

		// this.props.ajaxViewHandler('get', configClass.apiUrl.data+"?warna_plat=1&jenis_kendaraan&roda=2&mulai_dari=23-10-2020&sampai_dengan=23-10-2021")
		this.props.ajaxViewHandler('get', configClass.apiUrl.data + filter)
			.then(() => {
				const data = this.props.responseMsg;
				if (this.props.isSuccess) {
					message.destroy();
					this.setState({
						loading: false,
						data: data,
						err: false
					});
					setTimeout(function () {
						// window.print();

					}, 1000);
					
					let pesan = data?.data?.[0].message;
					if(data?.data?.[0].status == 1)
					{
						message.success({ content: pesan, duration: 5, key: 'toast'});
					}

					if(data?.data?.[0].status == 0)
					{
						message.warn({ content: pesan, duration: 5, key: 'toast'});
					}
				} else {
					console.log(data)
					const errTitle = 'error get laporan';
					this.setState({
						loading: false,
						data: null,
						err: true,
						errMsg: this.props.responseMsg
					});
					message.error({ content: errTitle, duration: 2, key: 'toast' });
				}
			}).catch((response) => {
				this.setState({
					loading: false,
					data: null,
					err: true,
					errMsg: 'unknown response'
				});
				console.log('gagal_get_laporan', response);
				message.error({ content: 'gagal request data, coba lagi', duration: 2, key: 'toast' });
			});
	}

	loadMasterList() {
		const rule = [
			{
				destination: {
					stateProgressName: "loadingJenisKendaraan",
					endPoint: configClass.apiUrl.jenis_kendaraan,
					stateDestination: "listJenisKendaraan",
				},
				nextDestination: {
					stateProgressName: "loadingWarnaPlat",
					endPoint: configClass.apiUrl.warna_plat,
					stateDestination: "listWarnaPlat",
					next: null,
				},
			},
			{
				destination: {
					stateProgressName: "loadingPayment",
					endPoint: configClass.apiUrl.payment,
					stateDestination: "listPayment",
				},
				nextDestination: {
					stateProgressName: "loadingKabupaten",
					endPoint: configClass.apiUrl.kabupaten,
					stateDestination: "listKabupaten",
					next: null,
				},
			},

		];

		this.setState({
			errComponent: false,
		});

		rule.map((item, index) => {
			if (index == rule.length - 1) {
				this.getMasterList(item, true);
			} else {
				this.getMasterList(item);
			}
		});
	}

	async getMasterList(rule, isFinal = false) {
		var destination = rule.destination;
		var nextDestination = rule.nextDestination;
		this.setState({ [destination.stateProgressName]: true });
		this.props
			.ajaxViewHandler("get", destination.endPoint)
			.then(() => {
				const data = this.props.responseMsg;
				if (this.props.isSuccess) {
					if (data.count != undefined) {
						let newState = null;
						if (this.state[destination.stateDestination].length == 0) {
							newState = data;
						} else {
							if (destination.stateProgressName.includes("_searching")) {
								newState = data;
							} else {
								const oldState = this.state[destination.stateDestination];
								newState = {
									count: data.count,
									next: data.next,
									previous: data.previous,
									results: [...oldState.results, ...data.results],
								};
							}
						}
						this.setState({
							[destination.stateDestination]: newState,
						});
					} else if (data.results != undefined) {
						this.setState({
							[destination.stateDestination]: data.results,
						});
					} else {
						if (Array.isArray(data)) {
							this.setState({
								[destination.stateDestination]: data,
							});
						} else {
							this.setState({
								[destination.stateDestination]: [data],
							});
						}
					}
					if (isFinal) {
						if (this.props.match.params.id != undefined) {
							// this.preview(this.props.match.params.id);
						}
					}
				} else {
					this.setState({
						errComponent: true,
					});
				}
				this.setState({ [destination.stateProgressName]: false });
			})
			.catch((response) => {
				//console.log('gagal_get_master', response);
				message.error({
					content: "gagal request data, coba lagi",
					duration: 2,
					key: "toast",
				});
				this.setState({
					errTitle: "gagal request data master",
					errMsg: response,
				});
				this.setState({ [destination.stateProgressName]: false });
			});
		//next function
		if (nextDestination != null) {
			const next = {
				destination: {
					stateProgressName: nextDestination.stateProgressName,
					endPoint: nextDestination.endPoint,
					stateDestination: nextDestination.stateDestination,
				},
				nextDestination: nextDestination.next,
			};
			this.getMasterList(next);
		}
	}

	generateSelect(stateName, url, key, value, keyDisplay = "") {
		let kabupatenId = null;
		let uptId = null;
		let isCookieValid = false;

		try {
			const rawCookie = Cookies.get(this.config.get_cookie_name() + "_upt");
			if (rawCookie) {
				const decoded = decodeURIComponent(rawCookie);
				const parsed = JSON.parse(decoded);
				kabupatenId = parsed.kabupaten;
				uptId = parsed.id;
				isCookieValid = Boolean(kabupatenId && uptId);
			}
		} catch (err) {
			console.warn("Cookie _upt tidak valid atau tidak ditemukan:", err);
		}


		// Auto-set kabupaten_id jika belum diset
		// if (stateName == "Kabupaten" && !this.state.kabupaten_id && kabupatenId) {
		// 	this.setState({ kabupaten_id: kabupatenId }, () => {
		// 		const rule = {
		// 			destination: {
		// 				stateProgressName: "loadingUpt",
		// 				endPoint: configClass.apiUrl.upt + "?kabupaten=" + kabupatenId,
		// 				stateDestination: "listUpt",
		// 			},
		// 			nextDestination: null,
		// 		};
		// 		this.getMasterList(rule);
		// 	});
		// 	return <Spin size="small" />;
		// }
		if (stateName == "Kabupaten" && !this.state.kabupaten_id && isCookieValid) {
			this.setState({ kabupaten_id: kabupatenId }, () => {
				const rule = {
					destination: {
						stateProgressName: "loadingUpt",
						endPoint: configClass.apiUrl.upt + "?kabupaten=" + kabupatenId,
						stateDestination: "listUpt",
					},
					nextDestination: null,
				};
				this.getMasterList(rule);
			});
			return <Spin size="small" />;
		}

		


		// Ambil list data
		const listData = this.state["list" + stateName];
		const isPaginated = listData?.count != undefined;
		const results = isPaginated ? listData.results : listData || [];

		// Ambil selected item
		const stateKey = stateName.toLowerCase() + "_id";
		const selectedId = this.state[stateKey];
		const selectedItem = results.find(item => String(item[key]) == String(selectedId));

		// Jika belum ada selectedItem, delay render
		if (selectedId && !selectedItem) {
			return <Spin size="small" />;
		}

		// Buat label
		const selectedLabel = selectedItem
			? (keyDisplay ? selectedItem[keyDisplay] : selectedItem[key]) + " - " + selectedItem[value]
			: "Cari / Pilih " + stateName;

		// Buat value
		const selectedValue = selectedItem
			? {
				value: String(selectedItem[key]),
				label: keyDisplay
					? selectedItem[keyDisplay] + " - " + selectedItem[value]
					: selectedItem[key] + " - " + selectedItem[value],
			}
			: undefined;

		// Render Select
		return this.state["loading" + stateName] ? (
			<img src={process.env.PUBLIC_URL + "/loading_crop.gif"} height="50" />
		) : (
			<RoundedSelect
				showSearch
				labelInValue
				defaultValue={selectedValue}
				// value={selectedValue}
				value={results.length > 0 ? selectedValue : undefined}
				placeholder={selectedLabel}
				// disabled={stateName == "Kabupaten" && Boolean(this.state.kabupaten_id)}
				// disabled={stateName == "Kabupaten" && Boolean(kabupatenId)}
				disabled={
					(stateName == "Kabupaten" && isCookieValid) ||
					(stateName == "Upt" && !this.state.kabupaten_id) ||
					(stateName == "Pegawai" && !this.state.upt_id)
				}
				optionFilterProp="children"
				optionLabelProp="label"
				onSearch={(val) => {
					let urls = url + "?search=" + val;
					if (stateName == "Upt") {
						urls = `${url}?kabupaten=${this.state.kabupaten_id}&search=${val}`;
					} else if (stateName == "Pegawai") {
						urls = `${url}?upt=${this.state.upt_id}&search=${val}`;
					}
					const rule = {
						destination: {
							stateProgressName: "loading" + stateName + "_searching",
							endPoint: urls,
							stateDestination: "list" + stateName,
						},
						nextDestination: null,
					};
					this.getMasterList(rule);
				}}
				onPopupScroll={(e) => {
					e.persist();
					const target = e.target;
					if (target.scrollTop + target.offsetHeight == target.scrollHeight) {
						if (listData?.next) {
							const rule = {
								destination: {
									stateProgressName: "loading" + stateName + "Paging",
									endPoint: listData.next,
									stateDestination: "list" + stateName,
								},
								nextDestination: null,
							};
							this.getMasterList(rule);
						}
					}
				}}
				allowClear
				style={{ width: "100%" }}
				size="small"
				onChange={(valObj) => {
					const val = valObj?.value;
					const stateKey = stateName.toLowerCase() + "_id";
					this.setState({ [stateKey]: val }, () => {
						if (stateName == "Kabupaten") {
							this.setState({ upt_id: undefined, listUpt: [], pegawai_id: undefined, listPegawai: [] }, () => {
								const rule = {
									destination: {
										stateProgressName: "loadingUpt",
										endPoint: configClass.apiUrl.upt + "?kabupaten=" + val,
										stateDestination: "listUpt",
									},
									nextDestination: null,
								};
								this.getMasterList(rule);
							});
						} else if (stateName == "Upt") {
							this.setState({ pegawai_id: undefined, listPegawai: [] }, () => {
								const rule = {
									destination: {
										stateProgressName: "loadingPegawai",
										endPoint: "pegawai/api/pegawai/?upt=" + val,
										stateDestination: "listPegawai",
									},
									nextDestination: null,
								};
								this.getMasterList(rule);
							});
						}
					});
				}}
				// onChange={(valObj) => {
				// 	const val = valObj?.value;
				// 	this.setState({ [stateKey]: val }, () => {
				// 		if (stateName == "Kabupaten") {
				// 			// Reset upt_id dan listUpt agar UPT tidak terselect
				// 			this.setState({ upt_id: undefined, listUpt: [] }, () => {
				// 				const rule = {
				// 					destination: {
				// 						stateProgressName: "loadingUpt",
				// 						endPoint: configClass.apiUrl.upt + "?kabupaten=" + val,
				// 						stateDestination: "listUpt",
				// 					},
				// 					nextDestination: null,
				// 				};
				// 				this.getMasterList(rule);
				// 			});
				// 		}
				// 	});
				// }}

			>
				{this.state["loading" + stateName + "_searching"] && (
					<Select.Option value="">
						<Spin size="small" />
					</Select.Option>
				)}

				{results.map((item) => {
					const itemValue = item[key];
					const isSelected = selectedValue?.value == itemValue;

					return (
						<Select.Option
							key={itemValue}
							value={itemValue}
							label={keyDisplay ? item[keyDisplay] + " - " + item[value] : item[key] + " - " + item[value]}
							selected={isSelected}
						>
							{keyDisplay ? item[keyDisplay] + " - " + item[value] : item[key] + " - " + item[value]}
						</Select.Option>
					);
				})}


				{listData?.next && (
					<Select.Option value="">
						<Spin size="small" />
					</Select.Option>
				)}
			</RoundedSelect>
		);
	}

	render() {
		const { data, loading, uptInfo } = this.state;
		const rows   = data?.data || [];
		const hasData = data != null && rows[0]?.status == 1;

		// UPT dari cookie atau state
		const uptNama = uptInfo?.nama || (() => {
			try {
				const raw = Cookies.get(this.config.get_cookie_name() + "_upt");
				if (!raw) return '';
				const p = JSON.parse(decodeURIComponent(raw));
				return p.nama || `UPT #${p.id}`;
			} catch { return ''; }
		})();

		const NAVY     = '#0f2847';
		const NAVY_MID = '#1a3a6b';

		const lbl = (txt) => (
			<span style={{ fontSize:11, fontWeight:600, color:'#475569', textTransform:'uppercase', letterSpacing:.5 }}>{txt}</span>
		);

		const fmtJumlah = (val) => {
			const n = parseInt(String(val || '0').replace(/[^0-9]/g, ''), 10);
			if (n === 0) return <span style={{ color:'#cbd5e1' }}>—</span>;
			return <span style={{ color:'#15803d', fontWeight:700, fontFamily:'monospace', whiteSpace:'nowrap' }}>{val}</span>;
		};

		const fmtPrint = (val) => {
			const n = parseInt(String(val || '0').replace(/[^0-9]/g, ''), 10);
			return n === 0 ? '—' : val;
		};

		return (
			<div>
				<Helmet>
					<title>{configClass.title + ' | ' + config.get_site_info().name}</title>
				</Helmet>

				{/* ── Konten layar ── */}
				<div className="lap-kasir-screen">

					<div className="card">
						<Row className="isi" gutter={[0, 14]}>

							{/* ══ FILTER PANEL ══ */}
							<Col span={24}>
								<div style={{ background:'#fff', borderRadius:14, overflow:'hidden', border:'1px solid #e2e8f0', boxShadow:'0 2px 12px rgba(15,40,71,0.07)' }}>

									{/* Header dark navy */}
									<div style={{ background:`linear-gradient(135deg,${NAVY} 0%,${NAVY_MID} 100%)`, padding:'16px 20px' }}>
										<div style={{ display:'flex', alignItems:'center', gap:12 }}>
											<div style={{ width:36, height:36, background:'rgba(251,191,36,0.15)', borderRadius:10, display:'flex', alignItems:'center', justifyContent:'center', fontSize:18 }}>🧾</div>
											<div>
												<div style={{ fontSize:14, fontWeight:700, color:'#fff' }}>Laporan Teller</div>
												<div style={{ fontSize:11, color:'#64748b' }}>Laporan penerimaan harian per teller / kasir</div>
											</div>
										</div>
									</div>

									{/* Form */}
									<Form
										layout="vertical" name="fdata" size="small" ref={this.formRef}
										disabled={loading}
										style={{ padding:'18px 20px 14px' }}
										onKeyDown={(e) => { if (e.key === 'Enter') e.preventDefault(); }}
									>
										<div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(220px,1fr))', gap:'0 16px' }}>

											{this.props.is_superuser ? (
												<>
													{/* Superadmin: bebas pilih Kabupaten → UPT → Teller untuk melihat penerimaan teller manapun */}
													<Form.Item name="kabupaten" label={lbl('Kabupaten')} style={{ marginBottom:10 }}>
														{this.generateSelect('Kabupaten', configClass.apiUrl.kabupaten, 'id', 'name')}
													</Form.Item>
													<Form.Item name="upt" label={lbl('UPT')} style={{ marginBottom:10 }}>
														{this.generateSelect('Upt', configClass.apiUrl.upt, 'id', 'nama', 'id')}
													</Form.Item>
													<Form.Item name="pembayaran_by" label={lbl('Teller')} style={{ marginBottom:10 }}>
														{this.generateSelect('Pegawai', 'pegawai/api/pegawai/', 'user', 'nama', 'nama')}
													</Form.Item>
												</>
											) : (
												/* UPT — dari cookie, disabled */
												<Form.Item label={lbl('UPT')} style={{ marginBottom:10 }}>
													<Input
														value={uptNama || 'Memuat...'}
														disabled
														style={{ borderRadius:8, height:32, background:'#f1f5f9', color:'#1e293b', fontWeight:600, cursor:'not-allowed' }}
													/>
													{/* Hidden field untuk UPT ID yang dikirim ke API */}
													<Form.Item name="upt" style={{ display:'none' }}>
														<Input type="hidden" />
													</Form.Item>
												</Form.Item>
											)}

											{/* Tanggal — wajib diisi */}
											<Form.Item
												name="mulai_dari_picker"
												label={lbl('Tanggal')}
												style={{ marginBottom:10 }}
												rules={[{ required:true, message:'Tanggal wajib dipilih' }]}
											>
												<RoundedDatePicker
													placeholder="Pilih tanggal"
													format="DD-MM-YYYY"
													style={{ width:'100%', borderRadius:8 }}
													onChange={(date, dateString) => {
														this.formRef.current.setFieldsValue({ mulai_dari: dateString });
														this.setState({ mulai_dari: dateString });
													}}
												/>
											</Form.Item>

										</div>

										{/* Hidden field tanggal untuk filter */}
										<Form.Item name="mulai_dari" style={{ display:'none' }}><Input type="hidden" /></Form.Item>

										{/* Buttons */}
										<div style={{ display:'flex', gap:10, paddingTop:4 }}>
											<Button
												key="btn-lihat"
												loading={loading}
												type="primary"
												disabled={loading}
												icon={!loading && <SearchOutlined />}
												style={{ borderRadius:9, height:36, paddingInline:20, fontWeight:700, background:NAVY, borderColor:NAVY }}
												onClick={() => {
													this.formRef.current.validateFields()
														.then(values => this.handleSubmitDetail(values))
														.catch(() => {});
												}}
											>
												Lihat Detail
											</Button>
											{data != null && (
												<Button
													key="btn-cetak"
													loading={loading}
													disabled={loading}
													icon={!loading && <PrinterOutlined />}
													style={{ borderRadius:9, height:36, paddingInline:20, fontWeight:600 }}
													onClick={this.handlePrint}
												>
													Cetak
												</Button>
											)}
										</div>
									</Form>
								</div>
							</Col>

							{/* ══ LOADING ══ */}
							{loading && (
								<Col span={24}>
									<div style={{ background:'#fff', borderRadius:14, padding:32, textAlign:'center', border:'1px solid #e2e8f0' }}>
										<Spin size="large" />
										<div style={{ marginTop:12, color:'#64748b', fontSize:13 }}>Memproses laporan, mohon tunggu...</div>
									</div>
								</Col>
							)}

							{/* ══ HASIL LAPORAN ══ */}
							{hasData && !loading && (
								<>
									{/* Info bar: UPT · Tanggal · Operator · Jumlah Kendaraan */}
									<Col span={24}>
										<div style={{
											background:`linear-gradient(135deg,${NAVY} 0%,${NAVY_MID} 100%)`,
											borderRadius:14, padding:'14px 22px',
											display:'flex', flexWrap:'wrap', alignItems:'center', gap:24,
											boxShadow:'0 4px 18px rgba(15,40,71,0.15)',
										}}>
											{[
												{ icon:'🏛️', label:'SAMSAT',   val: data.upt },
												{ icon:'📅', label:'Tanggal',  val: data.tanggal },
												{ icon:'👤', label:'Operator', val: data.operator },
											].map((item, i) => (
												<div key={i} style={{ display:'flex', flexDirection:'column', gap:2 }}>
													<span style={{ fontSize:10, color:'#94a3b8', fontWeight:700, textTransform:'uppercase', letterSpacing:.8 }}>{item.icon} {item.label}</span>
													<span style={{ fontSize:13, fontWeight:700, color:'#fff' }}>{item.val}</span>
												</div>
											))}
											<div style={{ marginLeft:'auto', display:'flex', alignItems:'center', gap:8, background:'rgba(251,191,36,0.15)', borderRadius:10, padding:'8px 16px' }}>
												<span style={{ fontSize:28, fontWeight:900, color:'#fbbf24', fontFamily:'monospace' }}>{rows.length}</span>
												<span style={{ fontSize:12, color:'#fbbf24', fontWeight:700, textTransform:'uppercase' }}>Kendaraan</span>
											</div>
										</div>
									</Col>

									{/* Summary Grid Cards */}
									<Col span={24}>
										<div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:12 }}>
											{[
												{ label:'BBNKB',   val: data.total_penerimaan_bbnkb,   sub: data.total_penerimaan_opsen_bbnkb, subLabel:'Opsen' },
												{ label:'PKB',     val: data.total_penerimaan_pkb,     sub: data.total_penerimaan_opsen_pkb,   subLabel:'Opsen' },
												{ label:'SWDKLLJ', val: data.total_penerimaan_swdkllj },
												{ label:'PNBP',    val: data.total_penerimaan_pnbp },
												{ label:'SP3',     val: data.total_penerimaan_sp3 },
											].map((card, i) => (
												<div key={i} style={{ background:'#fff', borderRadius:12, padding:'14px 16px', border:'1px solid #e2e8f0', boxShadow:'0 2px 8px rgba(15,40,71,0.06)' }}>
													<div style={{ fontSize:10, color:'#64748b', fontWeight:700, textTransform:'uppercase', letterSpacing:.8, marginBottom:6 }}>{card.label}</div>
													<div style={{ fontSize:18, fontWeight:900, color:NAVY, fontFamily:'monospace' }}>{card.val}</div>
													{card.sub && (
														<div style={{ fontSize:11, color:'#64748b', marginTop:6, paddingTop:6, borderTop:'1px dashed #e2e8f0' }}>
															{card.subLabel}: <span style={{ color:NAVY_MID, fontWeight:700, fontFamily:'monospace' }}>{card.sub}</span>
														</div>
													)}
												</div>
											))}
											<div style={{ background:`linear-gradient(135deg,${NAVY} 0%,${NAVY_MID} 100%)`, borderRadius:12, padding:'14px 16px', boxShadow:'0 4px 14px rgba(15,40,71,0.2)', display:'flex', flexDirection:'column', justifyContent:'center' }}>
												<div style={{ fontSize:10, color:'#94a3b8', fontWeight:700, textTransform:'uppercase', letterSpacing:.8, marginBottom:6 }}>TOTAL PENERIMAAN</div>
												<div style={{ fontSize:20, fontWeight:900, color:'#fbbf24', fontFamily:'monospace' }}>{data.total_penerimaan_all}</div>
											</div>
										</div>
									</Col>

									{/* Tabel modern */}
									<Col span={24}>
										<div style={{ background:'#fff', borderRadius:14, overflow:'hidden', border:'1px solid #e2e8f0', boxShadow:'0 2px 10px rgba(15,40,71,0.06)' }}>
											<div style={{ overflowX:'auto' }}>
												<table style={{ width:'100%', borderCollapse:'collapse', fontSize:12 }}>
													<thead>
														<tr style={{ background:`linear-gradient(135deg,${NAVY} 0%,${NAVY_MID} 100%)` }}>
															{[
																{ label:'No', rowSpan:2, align:'center' },
																{ label:'No. Polisi', rowSpan:2, align:'left' },
																{ label:'Nama Pemilik', rowSpan:2, align:'left' },
																{ label:'No. Notice', rowSpan:2, align:'center' },
															].map((h,i) => (
																<th key={i} rowSpan={h.rowSpan} style={{
																	padding:'9px 10px', color:'#fff', fontWeight:700,
																	textAlign:h.align, fontSize:11, textTransform:'uppercase', letterSpacing:.8,
																	whiteSpace:'nowrap', verticalAlign:'middle',
																	borderRight:'1px solid rgba(255,255,255,0.12)',
																}}>
																	{h.label}
																</th>
															))}
															<th colSpan={2} style={{
																padding:'9px 10px', color:'#fbbf24', fontWeight:700, textAlign:'center',
																fontSize:11, textTransform:'uppercase', letterSpacing:.8,
																borderRight:'1px solid rgba(255,255,255,0.12)',
																borderBottom:'1px solid rgba(255,255,255,0.2)',
															}}>
																PROVINSI
															</th>
															<th colSpan={2} style={{
																padding:'9px 10px', color:'#fbbf24', fontWeight:700, textAlign:'center',
																fontSize:11, textTransform:'uppercase', letterSpacing:.8,
																borderRight:'1px solid rgba(255,255,255,0.12)',
																borderBottom:'1px solid rgba(255,255,255,0.2)',
															}}>
																KABUPATEN/KOTA
															</th>
															{[
																{ label:'SWDKLLJ' },
																{ label:'PNBP' },
																{ label:'SP3' },
																{ label:'JUMLAH TOTAL', color:'#fbbf24' },
																{ label:'KET', align:'center' },
															].map((h,i) => (
																<th key={i} rowSpan={2} style={{
																	padding:'9px 10px', color: h.color || '#fff', fontWeight:700,
																	textAlign: h.align || 'right', fontSize:11, textTransform:'uppercase', letterSpacing:.8,
																	whiteSpace:'nowrap', verticalAlign:'middle',
																	borderLeft:'1px solid rgba(255,255,255,0.12)',
																}}>
																	{h.label}
																</th>
															))}
														</tr>
														<tr style={{ background:NAVY_MID }}>
															{['BBNKB','PKB','OPSEN BBNKB','OPSEN PKB'].map((h,i) => (
																<th key={i} style={{
																	padding:'6px 10px', color:'#cbd5e1', fontWeight:600,
																	textAlign:'right', fontSize:10, textTransform:'uppercase', whiteSpace:'nowrap',
																	borderRight:'1px solid rgba(255,255,255,0.1)',
																}}>
																	{h}
																</th>
															))}
														</tr>
													</thead>
													<tbody>
														{rows.map((item, idx) => {
															const rowBg = idx % 2 === 0 ? '#fff' : '#f8fafc';
															return (
																<tr key={idx} style={{ background: rowBg, borderBottom:'1px solid #f1f5f9' }}>
																	<td style={{ padding:'9px 10px', textAlign:'center', color:'#64748b', fontSize:12 }}>{idx + 1}</td>
																	<td style={{
																		padding:'9px 10px', fontWeight:700, color:NAVY, fontFamily:'monospace', letterSpacing:1, whiteSpace:'nowrap',
																		position:'sticky', left:0, zIndex:1, background:rowBg, borderRight:'2px solid #e2e8f0',
																	}}>{item.nomor_polisi}</td>
																	<td style={{ padding:'9px 10px', color:'#334155' }}>{item.nama_pemilik}</td>
																	<td style={{ padding:'9px 10px', textAlign:'center', color:'#475569', fontFamily:'monospace' }}>{item.nomor_notice}</td>
																	<td style={{ padding:'9px 10px', textAlign:'right' }}>{fmtJumlah(item.jumlah_bbnkb)}</td>
																	<td style={{ padding:'9px 10px', textAlign:'right' }}>{fmtJumlah(item.jumlah_pkb)}</td>
																	<td style={{ padding:'9px 10px', textAlign:'right' }}>{fmtJumlah(item.jumlah_opsen_bbnkb)}</td>
																	<td style={{ padding:'9px 10px', textAlign:'right' }}>{fmtJumlah(item.jumlah_opsen_pkb)}</td>
																	<td style={{ padding:'9px 10px', textAlign:'right' }}>{fmtJumlah(item.jumlah_swdkllj)}</td>
																	<td style={{ padding:'9px 10px', textAlign:'right' }}>{fmtJumlah(item.jumlah_pnbp)}</td>
																	<td style={{ padding:'9px 10px', textAlign:'right' }}>{fmtJumlah(item.jumlah_sp3)}</td>
																	<td style={{ padding:'9px 10px', textAlign:'right', fontWeight:700, color:NAVY, fontFamily:'monospace', whiteSpace:'nowrap' }}>{item.jumlah_total}</td>
																	<td style={{ padding:'9px 10px', textAlign:'center' }}>
																		{item.keterangan ? (
																			<span style={{ background:'#eff6ff', color:'#1d4ed8', fontSize:10, fontWeight:600, padding:'2px 8px', borderRadius:20, border:'1px solid #bfdbfe' }}>
																				{item.keterangan}
																			</span>
																		) : '—'}
																	</td>
																</tr>
															);
														})}
													</tbody>
													<tfoot>
														<tr style={{ background:NAVY, borderTop:'2px solid rgba(255,255,255,0.1)' }}>
															<td colSpan={4} style={{ padding:'11px 14px', textAlign:'right', fontWeight:700, color:'#fff', fontSize:12, textTransform:'uppercase', letterSpacing:.8 }}>Jumlah Total</td>
															{[
																data.total_penerimaan_bbnkb,
																data.total_penerimaan_pkb,
																data.total_penerimaan_opsen_bbnkb,
																data.total_penerimaan_opsen_pkb,
																data.total_penerimaan_swdkllj,
																data.total_penerimaan_pnbp,
																data.total_penerimaan_sp3,
															].map((val, i) => {
																const n = parseInt(String(val || '0').replace(/[^0-9]/g, ''), 10);
																return (
																	<td key={i} style={{ padding:'11px 14px', textAlign:'right', fontFamily:'monospace' }}>
																		{n === 0
																			? <span style={{ color:'#475569' }}>—</span>
																			: <span style={{ color:'#fbbf24', fontWeight:900, fontSize:14 }}>{val}</span>
																		}
																	</td>
																);
															})}
															<td style={{ padding:'11px 14px', textAlign:'right', fontWeight:900, color:'#fbbf24', fontSize:16, fontFamily:'monospace' }}>{data.total_penerimaan_all}</td>
															<td></td>
														</tr>
													</tfoot>
												</table>
											</div>
											<div style={{ padding:'10px 18px', background:'#f8fafc', borderTop:'1px solid #e2e8f0', fontSize:11, color:'#64748b' }}>
												Dicetak: {moment().format('DD-MM-YYYY HH:mm')}
											</div>
										</div>
									</Col>
								</>
							)}

						</Row>
					</div>
				</div>{/* end lap-kasir-screen */}

				{/* ── Print-only section ── */}
				{hasData && (
					<div className="lap-teller-print-only" style={{ display:'none' }}>
						<div style={{ textAlign:'center', marginBottom:12 }}>
							<div style={{ fontSize:16, fontWeight:'bold', textTransform:'uppercase' }}>Laporan Penerimaan Harian Teller</div>
							<div style={{ fontSize:13, fontWeight:'bold' }}>SAMSAT {data.upt?.toUpperCase()}</div>
						</div>
						<div style={{ fontWeight:'bold', marginBottom:10 }}>
							<div>SAMSAT : {data.upt?.toUpperCase()}</div>
							<div>TANGGAL : {data.tanggal?.toUpperCase()}</div>
							<div>OPERATOR : {data.operator?.toUpperCase()}</div>
						</div>
						<table className="laporan-table" cellPadding="5" border="1" style={{ tableLayout:'fixed', width:'100%' }}>
							<thead>
								<tr>
									<th style={{ width:40 }} rowSpan={2}>NO</th>
									<th style={{ width:100 }} rowSpan={2}>NO. POLISI</th>
									<th style={{ textAlign:'left' }} rowSpan={2}>NAMA PEMILIK</th>
									<th style={{ width:100 }} rowSpan={2}>NO. NOTICE</th>
									<th colSpan={2} style={{  width:200, textAlign:'center' }}>PROVINSI</th>
									<th colSpan={2} style={{ width:200, textAlign:'center' }}>KABUPATEN/KOTA</th>
									<th style={{ width:130, textAlign:'right' }} rowSpan={2}>SWDKLLJ</th>
									<th style={{ width:100, textAlign:'right' }} rowSpan={2}>PNBP</th>
									<th style={{ width:80, textAlign:'right' }} rowSpan={2}>SP3</th>
									<th style={{ width:130, textAlign:'right' }} rowSpan={2}>JUMLAH TOTAL</th>
									<th style={{ width:80 }} rowSpan={2}>KET</th>
								</tr>
								<tr>
									<th style={{ width:130, textAlign:'right' }}>BBNKB</th>
									<th style={{ width:130, textAlign:'right' }}>PKB</th>
									<th style={{ width:130, textAlign:'right' }}>OPSEN BBNKB</th>
									<th style={{ width:130, textAlign:'right' }}>OPSEN PKB</th>
								</tr>
							</thead>
							<tbody>
								{rows.map((item, idx) => (
									<tr key={idx}>
										<td style={{ textAlign:'center' }}>{idx + 1}</td>
										<td style={{ textAlign:'center' }}>{item.nomor_polisi}</td>
										<td style={{ textAlign:'left' }}>{item.nama_pemilik}</td>
										<td style={{ textAlign:'center' }}>{item.nomor_notice}</td>
										<td style={{ textAlign:'right' }}>{fmtPrint(item.jumlah_bbnkb)}</td>
										<td style={{ textAlign:'right' }}>{fmtPrint(item.jumlah_pkb)}</td>
										<td style={{ textAlign:'right' }}>{fmtPrint(item.jumlah_opsen_bbnkb)}</td>
										<td style={{ textAlign:'right' }}>{fmtPrint(item.jumlah_opsen_pkb)}</td>
										<td style={{ textAlign:'right' }}>{fmtPrint(item.jumlah_swdkllj)}</td>
										<td style={{ textAlign:'right' }}>{fmtPrint(item.jumlah_pnbp)}</td>
										<td style={{ textAlign:'right' }}>{fmtPrint(item.jumlah_sp3)}</td>
										<td style={{ textAlign:'right' }}>{item.jumlah_total}</td>
										<td style={{ textAlign:'center' }}>{item.keterangan || '—'}</td>
									</tr>
								))}
							<tr style={{ borderTop:'3px double #000' }}>
								<td colSpan={4} style={{ textAlign:'center', fontWeight:'bold' }}>JUMLAH TOTAL</td>
								<td style={{ textAlign:'right', fontWeight:'bold' }}>{data.total_penerimaan_bbnkb}</td>
								<td style={{ textAlign:'right', fontWeight:'bold' }}>{data.total_penerimaan_pkb}</td>
								<td style={{ textAlign:'right', fontWeight:'bold' }}>{data.total_penerimaan_opsen_bbnkb}</td>
								<td style={{ textAlign:'right', fontWeight:'bold' }}>{data.total_penerimaan_opsen_pkb}</td>
								<td style={{ textAlign:'right', fontWeight:'bold' }}>{data.total_penerimaan_swdkllj}</td>
								<td style={{ textAlign:'right', fontWeight:'bold' }}>{data.total_penerimaan_pnbp}</td>
								<td style={{ textAlign:'right', fontWeight:'bold' }}>{data.total_penerimaan_sp3}</td>
								<td style={{ textAlign:'right', fontWeight:'bold' }}>{data.total_penerimaan_all}</td>
								<td></td>
							</tr>
						</tbody>
						</table>
					</div>
				)}

			</div>
		);
	}
}

const mapStateToProps = function (state) {
	return state.configReducers
}

export default connect(
	mapStateToProps,
	{
		initHandler,
		setConfig,
		ajaxViewHandler,
		ajaxHandler
	}
)(LapTeller);